const { default: axios } = require("axios");
const Log = require("laravel-mix/src/Log");

module.exports = {
	data() {
		return {
			rules: {
				empatik: v => v == 'EMPATIK' || "La parola inserita non è valida",
				required: v => v != null && v.toString().trim() != "" || "Campo obbligatorio",
				requiredAtLeast3: v => v != null && v.toString().trim() != "" || "Campo obbligatorio",
				requiredIdOfObject: v => v != null && v.id != null || "Campo obbligatorio", // Per evitare che l'id di un oggetto sia NULL
				radioRequired: v => v != null || 'Campo obbligatorio',
				selectRequired: v => !!v || 'Campo obbligatorio',
				checkboxRequired: v => v == true || 'Campo obbligatorio',
				email: v => !v || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(v) || "Email non valida",
				// date: v => this.isValidFromSib || 'Data non valida',
				isNumber: v => !isNaN(v) || "Non è un numero",
				url: v => !v || /^https:\/\/[^\s$.?#].[^\s]*\/$/.test(v.trim()) || "URL non valido",
				numero_tessera: v => !v || v == '' || /^[0-9]{6,7}$/.test(v.trim()) || "Numero tessera non valido: 6 o 7 cifre richieste",
				phone_number: v => !v || v == '' || /^(\+|\d)\d+$/.test(v.trim()) || "Numero di cellulare non valido", // una versione semplice, controllo che il numero inizi o con un + o con un numero
				// codice_fiscale: v => !v || v == '' || /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{1}[0-9a-zA-Z]{1}[0-9]{1}[a-zA-Z]$/.test(v.trim()) || "Codice fiscale non valido",
				
				// Il codice fiscale adesso gestisce anche le omocodie: https://fiscomania.com/omocodia/#:~:text=A%20chi%20ci%20si%20deve,codice%20e%20risolvere%20la%20situazione
				codice_fiscale: v => !v || v == '' || /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{1}[0-9LMNPQRSTUV]{1}[0-9LMNPQRSTUV]{1}[a-zA-Z]$/.test(v.trim()) || "Codice fiscale non valido",
				
				// fiscal_code_unique: v => this.checkFiscalCodeExistence(v) || 'Il codice fiscale esiste già'

				//numero_civico: v => !v || v == '' || typeof v !== 'string' || /^[0-9]{1,4}[a-zA-Z]{0,2}$/.test(v.trim()) || "Numero civico non valido",
				numero_civico: v => !v || v == '' || v != null && v.toString().trim() != "" && v.toString().trim().length <= 24 || "Numero civico non valido",
			},

			// fiscalCodeExist: false
		}
	},

	methods: {
		customFilterByProperties(item, queryText, myProperties){
			let found = false;
			// Scorro in un elenco di properties inserite da me
			myProperties.forEach(function(myProp){
				if(item[myProp] != null && item[myProp].toLowerCase().indexOf(queryText.toLowerCase()) > -1){
					found = true;
				}
			})

			return found;
		},
		getSecondaryTextColorClass() {
			if (this.$vuetify.theme.isDark) {
				return 'text_secondary_dark'
			}
			else {
				return 'text_secondary_light'
			}
		},
		// async checkFiscalCodeExistence(fiscalCode) {
		// 	const promise = await axios.get(`/fiscal_code/exist/${fiscalCode}`);
		// 	promise.then(res => {
		// 		this.fiscalCodeExist = res.data;
		// 	});

		// 	return this.fiscalCodeExist;
		// },

		// Il seguente è stato spostato qui perché viene chiamato sia da Tecnici.vue che da PannelloTecnici.vue (non dal componente)
		// aggiungiModificaTecnico(datiTecnico, callbackSuccess){
		// 	// Si dà per scontato che giunti qui la validazione sia già andata a buon fine
			
		// 	// Elimino le info che non mi servono:
		// 	delete datiTecnico.corsi // L'inserimento/modifica/ecc di un corso non richiede il salvataggio del Tecnico
		// 	delete datiTecnico.edizioni_corsi
		// 	delete datiTecnico.corsi_complessivi
		// 	delete datiTecnico.rinnovi

		// 	if(datiTecnico.id == null || datiTecnico.id == ''){ // Nuovo tecnico
		// 		axios.post('/tecnici', datiTecnico)
		// 			.then(res => {
		// 				// this.isSavingTechnician = false;
		// 				// this.technicianSaved = true;
		// 				callbackSuccess()
		// 				// this.chiudiPannelloTecnico()
		// 				// this.getTecnici();
		// 			})
		// 			.catch(error => {})
		// 			.finally(() => {});
		// 	} else { // Aggiornamento tecnico esistente
		// 		axios.patch(`/tecnici/${datiTecnico.id}`, datiTecnico)
		// 			.then(res => {
		// 				// this.isSavingTechnician = false;
		// 				// this.technicianSaved = true;
		// 				callbackSuccess()
		// 			})
		// 			.catch(error => {})
		// 			.finally(() => {});
		// 	}

		// },

		formattaData(ymd){
			if(!ymd)
				return null;

			const [year, month, day] = ymd.split('-');
	  		return `${day}/${month}/${year}`;
		},

		formattaDatatime(ymdHms, separatoreDataOra = ' ', convertiDaUTC = false){
			if(!ymdHms)
				return null;

			if(convertiDaUTC){ // Converte da UTC all'ora locale
				// Chi arriva qui, solitamente ha formato "2024-09-23T10:37:07.000000Z" (la Z finale indica che è UTC)
				let localDate = new Date(ymdHms).toLocaleString('it-IT')
				// Lo torna nel formato: 09/10/2024, 09:00:00
				return localDate.replace(",", "")
			}

			// Separare data e ora
			const [date, time] = ymdHms.split(separatoreDataOra);

			// Separare anno, mese e giorno
			const [year, month, day] = date.split('-');
		
			// Separare ore e minuti
			const [hours, minutes] = time.split(':');
		
			// Restituire la data formattata senza secondi
			return `${day}/${month}/${year} ${hours}:${minutes}`;
		},

		ottieniUltimiAnni() {
			const currentYear = new Date().getFullYear();
			return Array.from({ length: 5 }, (_, i) => currentYear+1 - i);
		},
		ottieniUltimiAnniPiuUno() {
			const currentYear = new Date().getFullYear();
            return Array.from({ length: 4 }, (_, i) => (currentYear + 1 - i).toString());
		},

		getModelliEmail(callback){
			axios.get(`/modelli_email`)
			   	.then(res => {
					callback(res.data)
		   		})
	 	},

		getDatetimeAttuale(){
			const now = new Date();
		
			const year = now.getFullYear();
			const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Mesi da 0 a 11, quindi aggiungiamo 1
			const day = now.getDate().toString().padStart(2, '0');
		
			const hours = now.getHours().toString().padStart(2, '0');
			const minutes = now.getMinutes().toString().padStart(2, '0');
			const seconds = now.getSeconds().toString().padStart(2, '0');
		
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},

		clonaOggetto(obj){
			return JSON.parse(JSON.stringify(obj));
		},

		scrollToTop() {
			window.scrollTo({
			top: 0,
			behavior: 'smooth' // Aggiunge l'effetto di scroll fluido
		 });
	  	}, 

		redirectToFAQ() {
			// window.open('https://tecnici.csencorsi.it/#/faq', '_blank');
			window.location.href = '/#/faq';
		},

		redirectToTecnici() {
			window.location.href = '/#/tecnici'; // come faccio a mantenere lo stato? e non disautenticare l'utente se ci clicca?
		},

		setGuidaCompleta(chiave){
			// Se non sono admin esco
			if(!this.loggedAs || this.loggedAs.ruolo != 'admin')
				return

            if(window[chiave] == 1)
                return; // Guida già visualizzata

            axios.get('/set_guida_completa?chiave='+chiave)
                .then((res)=>{
                    window[chiave] = 1;
                })
        },
		isGuidaCompleta(chiave){
			// Chiavi possibili:
			// - is_guida_tecnici_completa
			// - is_guida_corsi_completa
			// - is_guida_referenti_completa
			// - is_guida_modelli_email_completa
			// - is_guida_circolari_automatiche_completa
			// - is_guida_email_inviate_completa

			return window[chiave]

			// if(this.$store.state.statusGuida.hasOwnProperty(chiave)){
			// 	return this.$store.state.statusGuida[chiave];
			// } else {
			// 	return false; // Se non trova la chiave l'avvio comunque
			// }
		},

		isEmpatikAdmin(){
			return window['is_empatik'] === 1 || window['is_empatik'] === '1';
		},

		conversioneTipoCircolare(tipo){
			if (tipo === 'reminder_1') return "🔔 1° Promemoria Rinnovo - Pre-scadenza";
			if (tipo === 'reminder_2') return "🔔 2° Promemoria Rinnovo - Pre-scadenza";
			if (tipo === 'sollecito_1') return "⏰ 1° Sollecito Rinnovo - Post-scadenza";
			if (tipo === 'sollecito_2') return "⏰ 2° Sollecito Rinnovo - Post-scadenza";
			if (tipo === 'invio_massivo') return "📩 Circolare Manuale";
			if (tipo === 'conferma_rinnovo_auto') return "☑️ Conferma Rinnovo - Pagamento automatico";
			if (tipo === 'conferma_rinnovo_manuale') return "✅ Conferma Rinnovo - Pagamento manuale";
			if (tipo === 'login_tecnico') return "👤 Login del tecnico";
			
			return "Tipo sconosciuto";
	 	},

		logout(){
			axios.get(`/logout`)
				.then(res => {
					window.location.replace("/");
				})
		},

		primaLetteraMaiuscola(string) {
			return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
		}
	},
	computed: {
		isLogged () { // TODO: più avanti si potrà eliminare
			return this.$store.state.isLogged;
		},
		loggedAs () {
			return this.$store.state.loggedAs;
		},
		darkMode () {
			return this.$store.state.darkMode;
		},

		// Impostazioni dei tour/guide condivise tra tutti
		tourOptions() {
			return {
				useKeyboardNavigation: false,
				labels: {
					buttonSkip: 'Salta guida',
					buttonPrevious: 'Precedente',
					buttonNext: 'Successivo',
					buttonStop: 'Fine'
				}
			}
		},
	}
}